import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  const categoryMap: Record<string, string> = {
    'kexue-renzhi': '科学认知',
    'pinlv-jiankang': '频率与健康',
    'xinli-yingxiang': '心理影响',
    'changjian-wuqu': '常见误区',
    'xing-jiaoyu': '性教育',
    'xingwei-guanli': '行为管理',
  };

  const isFeatured = variant === 'featured';
  const isCompact = variant === 'compact';

  return (
    <Link
      to={`/article/${article.slug}`}
      className={`group block rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 ${
        isFeatured ? 'lg:grid lg:grid-cols-2 lg:gap-0' : ''
      }`}
    >
      <div
        className={`relative overflow-hidden ${
          isFeatured ? 'aspect-[4/3] lg:aspect-auto lg:h-full' : 'aspect-[16/9]'
        } ${isCompact ? 'aspect-[3/2]' : ''}`}
      >
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        {!isFeatured && (
          <div className="absolute top-3 left-3">
            <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-white/90 text-foreground-800">
              {categoryMap[article.category] || article.category}
            </span>
          </div>
        )}
      </div>
      <div
        className={`p-4 md:p-5 bg-white ${
          isFeatured ? 'lg:flex lg:flex-col lg:justify-center' : ''
        }`}
      >
        {isFeatured && (
          <span className="inline-block px-2.5 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-2">
            {categoryMap[article.category] || article.category}
          </span>
        )}
        <h3
          className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 ${
            isFeatured ? 'text-xl md:text-2xl mb-3' : 'text-base md:text-lg mb-2'
          } ${isCompact ? 'text-sm mb-1.5' : ''}`}
        >
          {article.title}
        </h3>
        {!isCompact && (
          <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
            {article.excerpt}
          </p>
        )}
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
        </div>
      </div>
    </Link>
  );
}